import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "form_field_error",
  class: "position-absolute shadow bg-danger-subtle rounded p-3",
  style: {"bottom":"50px","z-index":"10"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Typograph = _resolveComponent("Typograph")!

  return (_openBlock(), _createElementBlock("div", {
    class: "position-relative justify-content-center d-flex",
    onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onMouseLeave())),
    onMouseover: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onMouseOver()))
  }, [
    _createVNode(_component_Button, {
      onOnClick: _ctx.onClick,
      fullWidth: "",
      loading: _ctx.loading,
      outline: _ctx.outline,
      label: _ctx.label,
      color: _ctx.color,
      id: _ctx.id
    }, null, 8, ["onOnClick", "loading", "outline", "label", "color", "id"]),
    (_ctx.showError && _ctx.fieldError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_Typograph, {
            variant: "subtitle",
            class: "text-danger"
          }, {
            default: _withCtx(() => [
              _cache[2] || (_cache[2] = _createElementVNode("i", { class: "fa-solid fa-exclamation-circle" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.fieldError), 1)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 32))
}